import store from '../store';

export default (value) => {
  if (typeof value !== 'number') return '';

  const symbol = store.state.preferences.currencySymbol;
  let transformedString;
  if (store.state.preferences.suffixCurrencySymbol) {
    if (value === 0) transformedString = `0.00 ${symbol}`;
    else transformedString = `${value > 0 ? '+' : '-'} ${Math.abs(value).toFixed(2)} ${symbol}`;
  } else {
    if (value === 0) transformedString = `${symbol} 0.00`; // eslint-disable-line no-lonely-if
    else transformedString = `${value > 0 ? '+' : '-'} ${symbol} ${Math.abs(value).toFixed(2)}`;
  }
  return transformedString;
};
